
export default {
  name: 'ButtonComponent',
  props: {
    icon: {
      type: String,
      default: '',
    },
    handleClick: {
      type: Function,
      default: null,
    },
    title: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: '#fff',
    },
    btn: {
      type: String,
      default: '',
    },
  },
  emits: ['click'],
  computed: {
    typeButton() {
      return `btn-${this.btn}`
    },
  },
  methods: {
    onClick(event) {
      // Se tiver função passada via prop, executa
      if (this.handleClick) {
        this.handleClick(event)
      }
      // Sempre emite o evento 'click' para o componente pai
      this.$emit('click', event)
    },
  },
}
